import * as React from 'react';
import './NavMenuStore.css';
import { PhoneFilled, MessageFilled } from '@ant-design/icons';
// import { REACT_APP_BUS_NAME, REACT_APP_BUS_SITE } from '../constants/StoreSetting';
import { checkIsWeb } from '../appRedux/actions/MobAppFn';
import {env} from '../env'

const {REACT_APP_BUS_NAME, REACT_APP_BUS_SITE} = env

export default class NavMenuStore extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return checkIsWeb().exist ? (
            
                <header className="Header div-flow">
                    <div id="top-bar" className='div-flow'>
                        <div className="container">
                            <ul>
                                <li><a href="/">{`${REACT_APP_BUS_NAME}`}</a></li>
                                <li><a href="/signin">Sign in</a></li>
                            </ul>
                            <ul>
                                {}
                                <li className="icons js-sales-chat">
                                    <a href={`${REACT_APP_BUS_SITE}`} className="js-live-chat icon xmini">
                                        <MessageFilled style={{ fontSize: '16px', color: '#dfdfdf', verticalAlign: 'baseline' }} />
                                    </a>
                                </li>
                                {}
                            </ul>
                        </div>
                    </div>        </header>
            

        ) : <>''</>;
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}

